import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/cloud-website/layouts/default.vue").then(m => m.default || m))
}